import React, { useState } from "react";
import { Button, Row, Col, Input, Space, Divider, Alert, Checkbox } from "antd";
import {
  FileTextOutlined,
  CheckCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import styles from "./QCReview.module.css";
import NewUnlistedFormEchs from "./NewUnlistedFormEchs";
import { Form } from "antd";
import RemarksEchs from "./RemarkEchs";
import RightSideFilePreview from "./RightSideFilePreview";
import uploadStyles from "./UploadJustification.module.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

interface IQCReviewProps {
  onNext?: () => void;
  onCancel?: () => void;
  caseInfo?: {
    caseId?: string;
    patientName?: string;
  };
  documentPath?: string;
  form: any;
  uploadedDocuments?: any;
  documentTypes?: any;
  activeKey: any;
  setUploadedDocuments: any;
  groupDocumentsByType?: any;
  handleSubmit: any;
  isProcedureSubmitted: boolean;
  isSaving: boolean;
  isSubmitting: boolean;
}

const QCReview: React.FC<IQCReviewProps> = ({
  onNext,
  onCancel,
  caseInfo,
  documentPath = "justification_letter_v2.pdf",
  form,
  uploadedDocuments,
  documentTypes,
  activeKey,
  setUploadedDocuments,
  groupDocumentsByType,
  handleSubmit,
  isProcedureSubmitted,
  isSaving,
  isSubmitting,
}) => {
  const { auth } = useSelector((state: RootState) => state);
  const items = Form.useWatch("items", form);

  return (
    <div className={styles.qcReviewContent}>
      {/* <div className={styles.qcReviewHeader}>
        <p className={styles.qcReviewSubtitle}>
          {caseInfo.caseId} • PATIENT: {caseInfo.patientName}
        </p>
      </div> */}

      <Row gutter={[16, 16]} style={{ height: "90vh" }}>
        {documentTypes
          ?.filter((docType: any) =>
            docType?.label?.toLowerCase()?.includes("justification"),
          )
          ?.map((docType: any) => (
            <Col xs={24} sm={24} md={14}>
              <div className={uploadStyles.uploadJustificationSection}>
                <div className={uploadStyles.uploadJustificationLabel}>
                  {docType?.label?.toLowerCase()?.includes("justification")
                    ? "Justification Letter"
                    : docType?.label}
                  <span className={uploadStyles.uploadJustificationRequired}>
                    *
                  </span>
                  <span className={uploadStyles.uploadJustificationBadge}>
                    REQUIRED
                  </span>
                </div>

                {groupDocumentsByType(uploadedDocuments)?.[docType?.labelId]
                  ?.length > 0 ? (
                  // && !docType?.multiple
                  <RightSideFilePreview
                    documents={
                      groupDocumentsByType(uploadedDocuments)?.[
                        docType?.labelId
                      ]
                    }
                    activeKey={activeKey}
                    setUploadedDocuments={setUploadedDocuments}
                    uploadedDocuments={uploadedDocuments}
                  />
                ) : (
                  <div
                    className={uploadStyles.uploadJustificationBoxNoDocument}
                  >
                    No Document Uploaded
                  </div>
                )}

                {/* {fileList.length > 0 && (
              <div className={styles.uploadJustificationFileInfo}>
                <p className={styles.uploadJustificationFileName}>{fileList[0]?.name}</p>
              </div>
            )} */}
              </div>
            </Col>
          ))}

        <Col xs={24} sm={24} md={10}>
          <div className={styles.qcReviewReviewSection}>
            {/* <h3 className={styles.qcReviewSectionTitle}>QC Review & Approval</h3>

            <div className={styles.qcReviewApprovalBox}>
              <label className={styles.qcReviewLabel}>Comments (Optional)</label>
              <Input.TextArea
                rows={6}
                placeholder="Add any comments or observations..."
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                className={styles.qcReviewTextarea}
              />
            </div>

            <div className={styles.qcReviewApprovalStatus}>
              <Checkbox
                checked={isApproved}
                onChange={(e) => setIsApproved(e.target.checked)}
              >
                <span className={styles.qcReviewCheckboxLabel}>Approve & Submit to Portal</span>
              </Checkbox>
            </div>

            <Alert
              message="Ready for Submission"
              description="All verification checks passed. Document is ready to be submitted to ECHS Portal."
              type="success"
              showIcon={true}
            /> */}
            <NewUnlistedFormEchs
              enhancementProcedure={[]}
              form={form}
              isProcedureSubmitted={isProcedureSubmitted}
            />
          </div>
        </Col>
      </Row>

      <div className={styles.qcReviewActionButtons}>
        <Space>
          {onCancel && (
            <Button size="large" onClick={onCancel}>
              Back
            </Button>
          )}

          {items?.length > 0 && isProcedureSubmitted && (
            <Button
              size="large"
              onClick={onNext}
              style={{ background: "#00549e", color: "#fff" }}
            >
              Next
            </Button>
          )}

          {!isProcedureSubmitted && (
            <Button
              type="primary"
              size="large"
              loading={isSaving}
              // disabled={!file || fileList.length === 0}
              onClick={() => handleSubmit(false)}
              style={{ background: "#F1F5F9", color: "#00549e" }}
            >
              {"Save As Draft"}
            </Button>
          )}

          {auth?.role?.role !== "FO_STAFF" && !isProcedureSubmitted && (
            <Button
              type="primary"
              size="large"
              loading={isSubmitting}
              onClick={() => handleSubmit(true)}
              style={{ background: "#00549E", color: "white" }}
            >
              {"Submit to Portal"}
            </Button>
          )}
        </Space>
      </div>
    </div>
  );
};

export default QCReview;
